module.exports = __webpack_public_path__ + "public/images/sold_out.eccc34db6f645a0f182821b742d163a0.png";